import React, { Component } from 'react';

import Store from './flux/Store';
import Navigation from './Navigation';
import Screen from './components/Screen';
import HomepageScreen from './screens/Homepage';
import ProductSelectionScreen from './screens/ProductSelection';
import ModelSelectionScreen from './screens/ModelSelection';
import ModelPerforateScreen from './screens/ModelPerforate';
import ConfiguratorScreen from './screens/Configurator';
import ConfiguredScreen from './screens/Configured';
import ModelColorScreen from './screens/ModelColor';
import ModelFitScreen from './screens/ModelFit';
import BookAppointmentScreen from './screens/BookAppointment';
import MailInsertScreen from './screens/MailInsert';
import ThankyouScreen from './screens/ThankYou';

import AppActions from "./flux/AppActions";
import LanguageStore from './flux/LanguageStore';


class ScreenContainer extends Component {

    state = {
      products : this.props.products,
      currentScreen : this.props.currentScreen,
      productCategory: this.props.productCategory
    };

    subscriptions = [];

    componentDidMount(){
        this.subscriptions.push(LanguageStore.addListener(() => {
            this.forceUpdate();
        }));
    }

    componentWillUnmount(){
        this.subscriptions.forEach(subscription => subscription.remove());
    }

    // componentWillReceiveProps(props){
    //     return {
    //         products : props.products,
    //         currentScreen : props.currentScreen,
    //         productCategory: props.productCategory
    //     }
    // }

    render() {
        return (
            <div>
                <Screen name="homepage" current={this.props.currentScreen.name}>
                    <HomepageScreen navigation={this.props.navigation} />
                </Screen>

                <Screen name="productSelection" current={this.props.currentScreen.name}>
                    <ProductSelectionScreen
                        navigation={this.props.navigation}
                        selected={this.props.productCategory}
                        onProductClick={category => AppActions.setProductCategory(category)}
                    />
                </Screen>

                <Screen name="modelSelection" current={this.props.currentScreen.name}>
                    <ModelSelectionScreen
                        navigation={this.props.navigation}
                        products={this.props.products}
                        category={this.props.productCategory}
                    />
                </Screen>

                <Screen name="modelPerforate" current={this.props.currentScreen.name}>
                    <ModelPerforateScreen navigation={this.props.navigation} />
                </Screen>

                <Screen name="modelColor" current={this.props.currentScreen.name}>
                    <ModelColorScreen navigation={this.props.navigation} />
                </Screen>

                <Screen name="configurator" current={this.props.currentScreen.name} >
                    <ConfiguratorScreen
                        navigation={this.props.navigation}
                    />
                </Screen>

                <Screen name="mailinsert" current={this.props.currentScreen.name}>
                    <MailInsertScreen navigation={this.props.navigation} />
                </Screen>

                <Screen name="configured" current={this.props.currentScreen.name}>
                    <ConfiguredScreen navigation={this.props.navigation} />
                </Screen>

                <Screen name="modelFit" current={this.props.currentScreen.name}>
                    <ModelFitScreen navigation={this.props.navigation} />
                </Screen>

                <Screen name="bookAppointment" current={this.props.currentScreen.name}>
                    <BookAppointmentScreen navigation={this.props.navigation} />
                </Screen>

                <Screen name="thankYou" current={this.props.currentScreen.name}>
                    <ThankyouScreen navigation={this.props.navigation} />
                </Screen>
            </div>
        );
    }
}

export default ScreenContainer;



// WEBPACK FOOTER //
// ./src/ScreenContainer.js